var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTasksIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6638 3.7508C14.2477 3.95599 14.6663 4.51228 14.6663 5.16634V11.833C14.6663 13.3978 13.3978 14.6663 11.833 14.6663H5.16634C4.51228 14.6663 3.95599 14.2477 3.7508 13.6638L5.14898 13.666L11.833 13.6663C12.8455 13.6663 13.6663 12.8455 13.6663 11.833V5.16634L13.6637 5.13235L13.6638 3.7508ZM11.4976 1.33301C12.326 1.33301 12.9976 2.00458 12.9976 2.83301V11.4976C12.9976 12.326 12.326 12.9976 11.4976 12.9976H2.83301C2.00458 12.9976 1.33301 12.326 1.33301 11.4976V2.83301C1.33301 2.00458 2.00458 1.33301 2.83301 1.33301H11.4976ZM8.97945 4.97945L6.38711 7.5718L5.73301 6.69967C5.56732 6.47876 5.25392 6.43399 5.03301 6.59967C4.81209 6.76536 4.76732 7.07876 4.93301 7.29967L5.93301 8.63301C6.11557 8.87643 6.47141 8.90172 6.68656 8.68656L9.68656 5.68656C9.88182 5.4913 9.88182 5.17472 9.68656 4.97945C9.4913 4.78419 9.17472 4.78419 8.97945 4.97945Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasksIcon);
export default __webpack_public_path__ + "static/media/tasks_icon.3e2a545a07e02a16c934555c9009b9d9.svg";
export { ForwardRef as ReactComponent };